import React from "react";
import { NavLink } from "react-router-dom";

export default function Cost() {
    return (

        <div>
            <div id="pageContainer">
                <span className="sectionHeader"> Tuition and Fees </span>
                <table>
                    <thead>
                        <tr >
                            <th>Ages</th>
                            <th>Full Time</th>
                            <th>2nd Child</th>
                            <th>Part Time</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                INFANTS
                                <br />6 weeks- 18 months
                            </td>
                            <td>$335.00</td>
                            <td>NA</td>
                            <td>$221.00</td>
                        </tr>

                        <tr>
                            <td>
                                TODDLER <br />
                                18 months-3 years{" "}
                            </td>
                            <td>$293.00</td>
                            <td>$220.00</td>
                            <td>$200.00</td>
                        </tr>

                        <tr>
                            <td>
                                PRESCHOOL <br />3 years-5 years{" "}
                            </td>
                            <td>$258.00</td>
                            <td>$194.00</td>
                            <td>$180.00</td>
                        </tr>
                        <tr>
                            <td>
                                SCHOOL AGE <br />
                            </td>
                            <td>$235.00</td>
                            <td>$176.00</td>
                            <td>$165.00</td>
                        </tr>
                        <tr>
                            <td>Before and After</td>
                            <td>$110.00</td>
                            <td>$85.00</td>
                            <td>$81.00</td>
                        </tr>
                        <tr>
                            <td>Before </td>
                            <td>$65.00</td>
                            <td>$51.00 </td>
                            <td>$51.00</td>
                        </tr>
                        <tr>
                            <td>After </td>
                            <td>$79.00</td>
                            <td>$63.00 </td>
                            <td>$63.00</td>
                        </tr>
                    </tbody>
                </table>
                <br />
                <h2>RATE WILL VERY BASED ON TRANSPORTATION NEEDS</h2>
                <p id="rateExplanation">
                    <span id="parHeader"> Registration Fee: </span>
                    $75.00 per family *Due upon registration & any lengthy
                    withdraw and re-enroll *non-refundable <br />
                    <span id="parHeader"> Preschool: </span> 3 years old and
                    Potty trained.
                    <br />
                    <span id="parHeader"> Full-Time: </span> 4 or 5 days of
                    child care Monday-Friday consisting of 5 or more hours per
                    day
                    <br />
                    <span id="parHeader"> Part-Time: </span> Children who receive 5 or less hours of
                    child care per day or are enrolled 2-3 days a week
                    <br />
                    <span id="parHeader"> Snow Days:</span> As a courtesy to our
                    families, you may drop off your school aged child (up to the
                    age of 12) and be charged the daily rate($65). This service has
                    limited enrollment. PLEASE ALWAYS CALL AHEAD FOR
                    CONFIRMATION. For Families already enrolled in our Before &
                    After care Program the fee is $35.00 a day.
                    <br />
                    <span id="parHeader"> Late Pick Up Fee: </span>$30 per child
                    every 10 minutes here past 5:30 pm Monday--Thursday & 5:15pm
                    Friday.
                    <br />
                    <span id="parHeader"> 1st Child: </span>1st child means the youngest
                    enrolled in the family.
                </p>
                <br />
                <h2>
                    ***Hours of Operation: Monday thru Friday 6:00AM—5:30PM
                    *** Effective 1/5/2026

                </h2>
                <br />
            </div>
            <div>
                <p className="sectionHeaderPrograms">
                    <NavLink to="/tuition">
                        {" "}
                        How to Pay Tuition
                        <i
                            className="fa fa-angle-double-right"
                            aria-hidden="true"></i>
                        <i
                            className="fa fa-angle-double-right"
                            aria-hidden="true"></i>
                    </NavLink>
                </p>
            </div>
        </div>



    );
}
